export default {
  /**
   * 会员卡类型格式化
   * type 会员卡相关 id
   * 1-年会员   2-月会员   3-特惠会员   4-特惠年卡   5-ios年卡
   * 6-ios月卡  7-新版周卡 8-新版月卡   9-新版季卡   10-新版半年卡  默认（会员卡）
   * 19-基础版  20-升级版
   */
  cardType: function (type) {
    let res = ''
    switch (type)
    {
      case 1:
      case 4:
      case 5:
        res = '年卡'
        break
      case 2:
      case 3:
      case 6:
      case 8:
        res = '月卡'
        break
      case 7:
        res = '周卡'
        break
      case 9:
        res = '季度卡'
        break
      case 10:
        res = '半年卡'
        break
      case 19:
        res = '基础版'
        break;
      case 20:
        res = '升级版'
        break;
      default:
        res = '会员卡'
        break
    }
    return res
  }
}



// WEBPACK FOOTER //
// ./src/filter/index.js